// ─────────────────────────────────────────────────────────────────────────────
// 🔑 TEAM PIPELINE'S WORDS, BY THE FIRM'S PARTNER TYPE (Hannah approved, 2026-11-02).
// A loan-officer firm says "borrowers" and "team members"; a realtor team (and anyone else) keeps "buyers" and
// "agents". The type is the firm's, sent by GET /api/doorlypro/firm/pipeline as firm_partner_type — read live from the
// broker of record's partner_users row, the same row requireBroker reads the firm (account) from — never the token.
// ─────────────────────────────────────────────────────────────────────────────
export function firmPipelineCopy(firmPartnerType) {
  if (firmPartnerType === 'loan_officer') {
    return {
      lead: 'Every borrower your team has submitted, and what each one is waiting on.',
      filterLabel: 'Team member',
      loading: 'Loading your team’s borrowers...',
      emptyFirm: 'Nobody at your firm has submitted a borrower yet.',
      emptyFiltered: 'No borrowers for that team member.',
      columns: ['Borrower', 'Team member', 'Status', 'What it’s waiting on', 'Submitted'],
    };
  }
  return {
    lead: 'Every buyer your team has submitted, and what each one is waiting on.',
    filterLabel: 'Agent',
    loading: 'Loading your team’s buyers...',
    emptyFirm: 'Nobody at your firm has submitted a buyer yet.',
    emptyFiltered: 'No buyers for that agent.',
    columns: ['Buyer', 'Agent', 'Status', 'What it’s waiting on', 'Submitted'],
  };
}
